.ai{padding:0.5rem;}